import './candidate-showcase.css'

import PropTypes from 'prop-types'

import ShowStory from '../stage/ShowStory'
import { SHOW_CANDIDATE_COPY } from './copy'
import CsApp, { APP_PARTICLES } from './scenes/CsApp'
import CsFair, { FAIR_PARTICLES } from './scenes/CsFair'
import CsFaq, { FAQ_PARTICLES } from './scenes/CsFaq'
import CsFlow, { FLOW_PARTICLES } from './scenes/CsFlow'
import CsHero, { HERO_PARTICLES } from './scenes/CsHero'
import CsTips, { TIPS_PARTICLES } from './scenes/CsTips'

/**
 * Use Case „Bewerbenden-Infopage“ als Showcase: Partikel-Herz zum Einstieg,
 * echte Aufnahmen aus der App, Fairness als Statements auf Blau.
 */
const SECTIONS = [
  {
    id: 'hero',
    height: 400,
    glow: ['#FE79A7', '#407BFF'],
    particles: HERO_PARTICLES,
    Scene: CsHero
  },
  {
    id: 'ablauf',
    height: 800,
    glow: ['#43DBBD', '#407BFF'],
    particles: FLOW_PARTICLES,
    Scene: CsFlow
  },
  {
    id: 'fair',
    height: 620,
    tone: 'blue',
    glow: ['#8FB0FF', '#FE79A7'],
    particles: FAIR_PARTICLES,
    Scene: CsFair
  },
  {
    id: 'tipps',
    height: 440,
    glow: ['#FFB628', '#FE79A7'],
    particles: TIPS_PARTICLES,
    Scene: CsTips
  },
  {
    id: 'faq',
    flow: true,
    glow: ['#407BFF', '#43DBBD'],
    particles: FAQ_PARTICLES,
    Scene: CsFaq
  },
  {
    id: 'app',
    height: 440,
    glow: ['#FE79A7', '#FFB628'],
    particles: APP_PARTICLES,
    Scene: CsApp
  }
]

export default function CandidateShowcase({ theme = 'dark' }) {
  return (
    <ShowStory sections={SECTIONS} copy={SHOW_CANDIDATE_COPY} theme={theme} />
  )
}

CandidateShowcase.propTypes = { theme: PropTypes.oneOf(['dark', 'light']) }

export const CandidateShowcaseLight = () => <CandidateShowcase theme='light' />
